export const dateLocaleFormats = {
  de: 'DD.MM.Y',
  en: 'MM-DD-Y',
};

export const dateWithTimeLocaleFormats = {
  de: 'DD.MM.Y HH:mm',
  en: 'MM-DD-Y HH:mm A',
};

export const months = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];
